import React from "react";
import { Trait } from "types";

export type TraitsContextValue = {
  traits: Trait[];
  traitsMap: Record<number, Trait>;
};

const TraitsContext = React.createContext<TraitsContextValue>({
  traits: [],
  traitsMap: {},
});

export default TraitsContext;
